export default __webpack_public_path__ + "static/media/Licenses_IMG-QA-01.d49c6fac.png";